export default function FooterSection() {
  const year = new Date().getFullYear();

  return (
    <footer
      id="footer"
      className="relative border-t border-white/5 py-10 px-4"
      style={{ background: "#060810" }}
    >
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo + brand */}
          <div className="flex items-center gap-3">
            <img
              src="https://public.readdy.ai/ai/img_res/935da4ed-aa52-4aee-8ed3-535e0baa27dd.png"
              alt="SolidHardware.net"
              className="h-8 w-auto object-contain opacity-80"
            />
            <span className="text-white/50 text-sm font-mono">solidhardware.net</span>
          </div>

          {/* Nav links */}
          <nav className="flex items-center gap-6 flex-wrap justify-center">
            {[
              { label: "Hero", href: "#hero" },
              { label: "About", href: "#about" },
              { label: "Sign Up", href: "#signup" },
              { label: "Social", href: "#social" },
            ].map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-gray-500 hover:text-cyan-400 text-sm transition-colors duration-200 cursor-pointer"
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* Copyright */}
          <p className="text-gray-600 text-xs text-center md:text-right">
            &copy; {year} SolidHardware.net &mdash; All rights reserved.
          </p>
        </div>

        {/* Bottom tagline */}
        <div className="mt-8 pt-6 border-t border-white/5 text-center">
          <p className="text-gray-700 text-xs font-mono tracking-widest uppercase">
            Precision &bull; Performance &bull; Reliability
          </p>
        </div>
      </div>
    </footer>
  );
}
